import BaseApi from './BaseApi';

/**
 * API for managing workflow information
 */
const create = () => {  // this will change for prod deployment
    // Create and configure an apisauce-based api object.
    const api = BaseApi.create({
        errorCodes: [500]
    });

    const revertPermissionsForCancelledTicket = async (viewModelId, taxYear) => {
        var payload = { viewModelId: viewModelId, taxYear: taxYear };
        let url = `virTickets/revert`;
        var response = await api.post(url, payload);
        return response;
    }

   
    // Return back a collection of functions
    return { revertPermissionsForCancelledTicket }
}

// let's return back our create method as the default.
export default {
    create
}
